import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// UI-P1: nut moi truong (tier badge + theme toggle) thay the demo <header> 56px.
// Self-contained: open-state + click-outside noi bo; chi nhan DATA props.
// Theme write di qua onThemePresetChange san co (KHONG prop moi cong khai).
import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "../../styles/ohlc-header.module.css";
const DARK_THEMES = ["classic-dark", "trading-night", "midnight-blue", "high-contrast"];
export function TopbarEnvPopover({ patTier, theme = "classic-dark", onThemePresetChange, upgradeUrl, portalRoot, t, }) {
    const [open, setOpen] = useState(false);
    const [pos, setPos] = useState(null);
    const btnRef = useRef(null);
    const panelRef = useRef(null);
    const toggle = useCallback(() => {
        setOpen((prev) => {
            if (!prev) {
                const r = btnRef.current?.getBoundingClientRect();
                if (r) {
                    // eslint-disable-next-line no-restricted-globals -- SSR-safe viewport read for fixed portal coords.
                    const vw = typeof window !== "undefined" ? window.innerWidth : 1024;
                    setPos({ top: r.bottom + 4, left: Math.max(8, Math.min(r.left, vw - 240)) });
                }
                else {
                    setPos(null);
                }
            }
            return !prev;
        });
    }, []);
    useEffect(() => {
        if (!open)
            return;
        const onDown = (e) => {
            const el = e.target;
            if (el && (btnRef.current?.contains(el) || panelRef.current?.contains(el)))
                return;
            setOpen(false);
        };
        // eslint-disable-next-line no-restricted-globals -- click-outside dismiss (same pattern as OHLCHeader).
        document.addEventListener("mousedown", onDown);
        // eslint-disable-next-line no-restricted-globals -- click-outside dismiss (same pattern as OHLCHeader).
        return () => document.removeEventListener("mousedown", onDown);
    }, [open]);
    const isDark = DARK_THEMES.includes(theme);
    const flipTheme = () => {
        onThemePresetChange?.(isDark ? "modern-light" : "classic-dark");
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("button", { type: "button", ref: btnRef, className: `${styles.selectorBtn} ${open ? styles.selectorBtnOpen : ""}`, onClick: toggle, "aria-expanded": open, "aria-haspopup": "dialog", title: t("header.settingsTitle"), "aria-label": t("header.settingsTitle"), "data-testid": "topbar-env-btn", children: [_jsx("span", { className: styles.liveBadgeDot, "aria-hidden": "true" }), (patTier ?? "free").toUpperCase()] }), open && pos && typeof document !== "undefined" && createPortal(_jsxs("div", { ref: panelRef, role: "dialog", "aria-label": t("header.settingsTitle"), className: styles.envPopover, style: { top: pos.top, left: pos.left }, children: [_jsxs("div", { className: styles.envRow, children: [_jsxs("span", { children: [t("settings.theme"), ": ", (patTier ?? "free").toUpperCase()] }), upgradeUrl && (_jsx("a", { href: upgradeUrl, target: "_blank", rel: "noopener noreferrer", title: t("header.upgradePro"), children: t("header.upgradePro") }))] }), onThemePresetChange && (_jsxs("button", { type: "button", onClick: flipTheme, title: isDark ? t("theme.switchToLight") : t("theme.switchToDark"), "data-testid": "topbar-theme-toggle", children: [t("settings.theme"), ": ", isDark ? t("theme.dark") : t("theme.light")] }))] }), 
            // eslint-disable-next-line no-restricted-globals -- portal fallback: same pattern as S9 chart-type portal.
            portalRoot ?? document.body)] }));
}
